import { render, staticRenderFns } from "./PCExample.vue?vue&type=template&id=63d0fa21&scoped=true&"
import script from "./PCExample.vue?vue&type=script&lang=js&"
export * from "./PCExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0fa21",
  null
  
)

export default component.exports